import React, { useState, useContext } from 'react';
import isUndefined from 'lodash/isUndefined';

import { locationState } from './appContext/location';
import { ContextName } from './appContext/contextName';
import { tracking } from './appContext/tracking';

const appContext = React.createContext(
  __SERVER__
    ? Object.values(ContextName).reduce(
        (acc, value) => ({
          ...acc,
          [value]: null,
        }),
        {},
      )
    : __CONTEXT__,
);

const experimentsState = (initialState) => {
  const [experiments, setExperiments] = useState(initialState);

  const updateExperiments = (updatedExperiments) => {
    setExperiments({ ...experiments, ...updatedExperiments });
  };

  return {
    [ContextName.EXPERIMENTS]: experiments,
    [ContextName.UPDATE_EXPERIMENTS]: updateExperiments,
  };
};

export const getDefaultStore = ({
  ldtEnv,
  userAgent,
  countryCode,
  cookies,
  userSelectedLocale,
  experiments,
  partnerSession,
}) => {
  return {
    [ContextName.LDT_ENV]: ldtEnv,
    [ContextName.USER_AGENT]: userAgent,
    [ContextName.COUNTRY_CODE]: countryCode,
    [ContextName.COOKIES]: cookies,
    [ContextName.PARTNER_SESSION]: partnerSession,
    [ContextName.USER_SELECTED_LOCALE]: userSelectedLocale,
    [ContextName.TRACKING]: tracking(),
    ...experimentsState(experiments),
    ...locationState(),
  };
};

export const serverToClientStore = () => {
  return getDefaultStore({
    ldtEnv: __CONTEXT__[ContextName.LDT_ENV],
    userAgent: __CONTEXT__[ContextName.USER_AGENT],
    countryCode: __CONTEXT__[ContextName.COUNTRY_CODE],
    cookies: __CONTEXT__[ContextName.COOKIES],
    userSelectedLocale: __CONTEXT__[ContextName.USER_SELECTED_LOCALE],
    experiments: __CONTEXT__[ContextName.EXPERIMENTS],
    partnerSession: __CONTEXT__[ContextName.PARTNER_SESSION],
  });
};

export const useAppContext = () => {
  const context = useContext(appContext);

  if (isUndefined(context)) {
    throw new Error('useAppContext must be used within a AppContextProvider');
  }

  return context;
};
export default appContext;
